import {ChangeDetectorRef, Component} from '@angular/core';
import { AlertController, NavController, NavParams, ViewController } from 'ionic-angular';
import { FormGroup } from "@angular/forms";
import { TestoBleService } from "../../services/testo-ble.service";
import { Storage } from "@ionic/storage";
import {ReportMeasurementPage} from "../report-measurement/report-measurement";

@Component({
  selector: 'page-report-measurement-get-testo-ble',
  templateUrl: 'report-measurement-get-testo-ble.html',
})
export class ReportMeasurementGetTestoBlePage {

  form: FormGroup;
  page: ReportMeasurementPage;

  deviceName = '';
  deviceLastServiceDate = '';
  deviceSerial = '';

  statusPercentage = 0;
  statusMessage = '';

  timestamp:Date;
  values = {};
  descriptions = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public ble: TestoBleService,
    public alertCtrl: AlertController,
    public storage: Storage,
    public changeDetector: ChangeDetectorRef,
  ) {
    this.form = navParams.get('form');
    this.page = navParams.get('page');
  }

  start(){
    this.storage.get('accepted_location_services').then((val) => {
      if(val){
        this.getData();
      } else {
        this.askForPermission();
      }
    }).catch(() => {
      this.askForPermission();
    });
  };

  askForPermission(){
    this.alertCtrl.create({
      title: 'Locatie toestemming',
      message: 'De Maintenanz App gebruikt locatieservices om te kunnen verbinden met uw Testo 300 rookgasmeter via Bluetooth Low Energy en om te registreren waar u zich bevindt op het moment dat u uw werkorder voltooid. De locatieservices worden alleen gebruikt tijdens het gebruik van de app.',
      buttons: [
        {
          text: 'Annuleren',
          role: 'cancel',
          handler: () => {
            this.alertCtrl.create({
              title: 'Toestemming geweigerd',
              message: 'Toegang tot locatieservices is nodig om te verbinden met uw Test 300 rookgasmeter via Bluetooth Low Energy. Zonder deze toestemming, kunt u geen gebruik maken van deze koppeling. De rest van de app kunt u wel blijven gebruiken.',
              buttons: ['OK']
            }).present();
          }
        },
        {
          text: 'Verder',
          handler: () => {
            this.getData();
          }
        }
      ]
    }).present();
  }

  private updateStatus(text, percentage){
    this.statusMessage = text;
    this.statusPercentage = percentage;
    this.changeDetector.detectChanges();
  }

  private getData(){
    this.ble.getData((text, progress) => {
      this.updateStatus(text, progress);
    }).then((data: any) => {
      this.storage.set('accepted_location_services', '1');
      let result = this.processData(data);
      if(result){
        this.submit();
      } else {
        this.alertCtrl.create({
          title: 'Fout',
          message: 'De ontvangen gegevens zijn onvolledig.',
          buttons: ['OK']
        }).present();
      }
    }).catch((err) => {
      console.log(JSON.stringify(err));
    });
  }

  private processData(data){
    console.log('Measurement data');
    console.log(data);
    if(data.timeStamp) this.timestamp = new Date(data.timeStamp);
    if(data.device.name) this.deviceName = data.device.name;
    else if(data.device.deviceIdentifier) this.deviceName = data.device.deviceIdentifier;
    if(data.device.lastServiceDate) this.deviceLastServiceDate = data.device.lastServiceDate;
    if(data.device.serial) this.deviceSerial = data.device.serial;
    console.log(data.device);
    let hasData = false;
    if(data.channels){
      for(let i = 0; i < data.channels.length; i++){
        let channel = data.channels[i];
        // @ts-ingnore
        if(channel.type.xmlid != null && channel.unit.xmlid != null && channel.values[0].value != null){
          hasData = true;
          let id = channel.type.xmlid + '_' + channel.unit.xmlid;
          this.values[id] = channel.values[0].value;
          this.descriptions[id] = channel.values[0].description;
        }
      }
    }
    console.log(this.values);
    return hasData;
  }

  private submit(){
    let maxValidValue = 100000;
    let mapping = [
      ['CO_Dil_UNIT_PPM', 'co_ppm'],
      ['CO2_UNIT_PERCENT', 'co2_percent'],
      ['O2_UNIT_PERCENT', 'o2_percent'],
      ['T_Flue_UNIT_DEG_C', 't_flue_deg_c'],
      ['T_Air_UNIT_DEG_C', 't_air_deg_c'],
      ['Efficiency_UNIT_PERCENT', 'efficiency_hi_percent'],
      ['etaHS_UNIT_PERCENT', 'efficiency_hs_percent'],
      ['PStat_UNIT_MBAR', 'p_stat_mbar'],
      ['PDyn_UNIT_MBAR', 'p_dyn_mbar'],
      ['Pburn_UNIT_MBAR', 'p_burn_mbar'],
    ];
    for(let i = 0; i < mapping.length; i++){
      if(this.values[mapping[i][0]] != null && this.values[mapping[i][0]] <= maxValidValue){
        let value = Math.round(this.values[mapping[i][0]]*10)/10; // Round to 1 decimal
        this.form.get(mapping[i][1]).setValue(value);
      } else {
        this.form.get(mapping[i][1]).setValue('');
      }
    }
    // Set t_delta_deg_c
    if(this.values['T_Air_UNIT_DEG_C'] < maxValidValue && this.values['T_Flue_UNIT_DEG_C'] < maxValidValue){
      this.page.calculateDeltaT(this.form);
    }
    // Device
    if(this.deviceSerial){
      this.form.get('device_sn').setValue(this.deviceSerial);
    }
    if(this.deviceLastServiceDate){
      this.form.get('device_last_service_date').setValue(this.deviceLastServiceDate);
    }
    // Convert values
    this.page.convertPpmToMgKwh(this.form);
    if(this.form.value.efficiency_hi_percent && !this.form.value.efficiency_hs_percent){
      this.page.convertEfficiencyHiToHs(this.form);
    } else if (this.form.value.efficiency_hs_percent && !this.form.value.efficiency_hi_percent) {
      this.page.convertEfficiencyHsToHi(this.form);
    }
    // Show alert
    this.alertCtrl.create({
      title: 'Gegevens gelezen',
      message: 'De gegevens uit uw Testo rookgasmeter zijn ingevuld.',
      buttons: ['OK']
    }).present();
    // Close modal
    this.closeModal();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportMeasurementGetTestoBlePage');
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-measurement-get-testo-ble/report-measurement-get-testo-ble.ts